"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ATTRIBUTE_PERSONA_TYPE_SPEAKER = exports.ATTRIBUTE_PERSONA_TYPE_HOST = void 0;
var ATTRIBUTE_PERSONA_TYPE_HOST = exports.ATTRIBUTE_PERSONA_TYPE_HOST = 'host';
var ATTRIBUTE_PERSONA_TYPE_SPEAKER = exports.ATTRIBUTE_PERSONA_TYPE_SPEAKER = 'speaker';